import { Injectable } from '@angular/core'
import { Store } from '@ngrx/store'
import {
  GlobalMessageActions,
  GlobalMessageService,
  GlobalMessageType,
  StateWithGlobalMessage
} from '@spartacus/core'
import { BehaviorSubject } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class EbGlobalMessageService extends GlobalMessageService {
  cartInitializationError$ = new BehaviorSubject(undefined)
  constructor(protected store: Store<StateWithGlobalMessage>) {
    super(store)
  }

  handleCartInitializationError(message: any) {
    this.cartInitializationError$.next(message)
  }

  removeAllMessages() {
    Object.keys(GlobalMessageType).forEach(type => {
      this.store.dispatch(new GlobalMessageActions.RemoveMessagesByType(GlobalMessageType[type]))
    })
    this.cartInitializationError$.next(undefined)
  }
}
